module.exports = __webpack_public_path__ + "img/check_approved.6702b194.svg";